module.exports = __webpack_public_path__ + "static/img/M106P_A.bfdd1d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/M106P_A.jpg
// module id = dims
// module chunks = 0